import { render, staticRenderFns } from "./supRegDetail.vue?vue&type=template&id=2aa6f710&scoped=true&"
import script from "./supRegDetail.vue?vue&type=script&lang=js&"
export * from "./supRegDetail.vue?vue&type=script&lang=js&"
import style0 from "./supRegDetail.vue?vue&type=style&index=0&id=2aa6f710&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa6f710",
  null
  
)

export default component.exports